import React, { useState, useEffect } from "react";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/Spends.scss";
import { useNavigate } from "react-router-dom";
import SpendsCard from "./SpendsCard";
import { connect } from "react-redux";
import {
  getSpendList,
  deleteSpend,
  addNewSpend,
  updateExistingSpend,
} from "../../Services/Spends/action";
import { Modal, Spinner, Button } from "react-bootstrap";
import { toast } from "react-toastify";

const Spends = (props) => {
  const {
    loading,
    spends,
    getSpend,
    deletingSpend,
    addingSpend,
    updatingSpend,
    success,
  } = props;
  const [spendList, setSpendList] = useState([]);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [spendId, setSpendId] = useState(0);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [spendData, setSpendData] = useState({
    id: null,
    title: "",
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const handleAddClick = () => {
    setIsUpdate(false);
    setSpendData({
      ...spendData,
      id: null,
      name: "",
    });
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSpendData({
      ...spendData,
      id: null,
      name: "",
    });
    setIsUpdate(false);
  };

  useEffect(() => {
    if (!spendList.length) {
      getSpend();
    }
  }, [spendList]);

  useEffect(() => {
    if (spends?.length) {
      setSpendList(spends);
    }
  }, [spends]);

  const handleSpendUpdate = (e, spend) => {
    e.preventDefault();
    setIsUpdate(true);
    setSpendData({
      ...spendData,
      id: spend?.id,
      name: spend?.name,
    });
    setShow(true);
  };
  const handleSpendSubmit = async () => {
    if (spendData?.name) {
      try {
        isUpdate
          ? await updatingSpend(spendData?.id, spendData)
          : await addingSpend({ name: spendData?.name });
        if (!loading && success) {
          setSpendData({
            id: null,
            name: "",
          });
          setIsUpdate(false);
          setShow(false);
          setIsLoading(true);
          setTimeout(async () => {
            await getSpend();
            setIsLoading(false);
          }, 1000);
        }
      } catch (error) {
        toast.error("Error:", error);
      }
    } else {
      toast.error("Oops, Not valid: Please Insert Valid title of spend");
      return;
    }
  };

  const spendDeletingReq = (event, spId) => {
    event.preventDefault();
    setSpendId(spId);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setSpendId(null);
  };

  const handleSpendDelete = async (event) => {
    event.preventDefault();
    if (spendId !== undefined && spendId !== null && spendId !== 0) {
      try {
        await deletingSpend(spendId);
        if (!loading && success) {
          setDeleteModal(false);
          setIsLoading(true);
          setTimeout(async () => {
            await getSpend();
            setIsLoading(false);
          }, 1000);
        }
      } catch (error) {
        toast.error("Error:", error);
      }
    } else {
      toast.error("Invalid Request");
      return;
    }
  };

  return (
    <Sidebarlayout>
      <div className="main-spends">
        <div className="page-title">
          <h4>Spends</h4>
          <div className="edit-btn">
            <button className="custom-btn" onClick={handleAddClick}>
              Add
            </button>
          </div>
        </div>
        <div className="content-part">
          {(!loading && !isLoading) ? (
            <div className="spends-card-row">
              <div className="row">
                {spendList.map((spends, index) => (
                  <SpendsCard
                    spends={spends}
                    key={index}
                    spendDelete={deletingSpend}
                    handleSpendUpdate={handleSpendUpdate}
                    spendDeletingReq={spendDeletingReq}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className="d-flex">
              <Spinner animation="rounded" size="sm" />
              Loading Spends...
            </div>
          )}
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{isUpdate ? "Update Spend" : "Add Spend"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="Spend-input-block">
            <h6 className="label mb-1" htmlFor="name">
              Title
            </h6>
            <input
              className="input-css"
              type="text"
              name="name"
              id="name"
              value={spendData?.name}
              onChange={(e) => {
                setSpendData({ ...spendData, name: e.target.value });
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancle
          </Button>
          <Button variant="primary" onClick={handleSpendSubmit}>
            {loading ? <Spinner size="sm" animation="rounded" /> : "Save Spend"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Body>
          <div className="d-flex flex-column">
            <p>Are You sure to delete this Spend?</p>
            <p>{spends?.name}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleSpendDelete}
            disabled={loading}
          >
            {!loading ? "Delete" : <Spinner size="sm" animation="rounded" />}
          </Button>
        </Modal.Footer>
      </Modal>
    </Sidebarlayout>
  );
};

export const mapStateToProps = (state) => {
  return {
    spends: state.spendReducer.spendList,
    loading: state.spendReducer.loading,
    success: state.spendReducer.success,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getSpend: () => {
      dispatch(getSpendList());
    },
    deletingSpend: (id) => {
      dispatch(deleteSpend(id));
    },
    addingSpend: (data) => {
      dispatch(addNewSpend(data));
    },
    updatingSpend: (id, data) => {
      dispatch(updateExistingSpend(id, data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Spends);
